var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2913)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_2913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 6H14C11.7909 6 10 7.79086 10 10V28C10 30.2091 11.7909 32 14 32H32C34.2091 32 36 30.2091 36 28V10C36 7.79086 34.2091 6 32 6Z",
    fill: "#A92C2C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32 2H14C11.7909 2 10 3.79086 10 6V24C10 26.2091 11.7909 28 14 28H32C34.2091 28 36 26.2091 36 24V6C36 3.79086 34.2091 2 32 2Z",
    fill: "#F13838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4191 11.99H17.6941V10.82C18.1641 10.82 18.5391 10.78 18.8191 10.7C19.1091 10.62 19.3391 10.49 19.5091 10.31C19.6791 10.12 19.8291 9.85 19.9591 9.5H21.0691V20H19.4191V11.99ZM25.5 20.15C24.67 20.15 24.03 19.93 23.58 19.49C23.14 19.04 22.92 18.395 22.92 17.555V16.625C22.92 16.105 23.005 15.67 23.175 15.32C23.345 14.96 23.62 14.68 24 14.48V14.45C23.65 14.26 23.39 14 23.22 13.67C23.06 13.33 22.98 12.9 22.98 12.38V11.945C22.98 11.105 23.195 10.465 23.625 10.025C24.065 9.575 24.69 9.35 25.5 9.35C26.31 9.35 26.93 9.575 27.36 10.025C27.8 10.465 28.02 11.105 28.02 11.945V12.38C28.02 13.38 27.68 14.07 27 14.45V14.48C27.38 14.68 27.655 14.96 27.825 15.32C27.995 15.67 28.08 16.105 28.08 16.625V17.555C28.08 18.395 27.855 19.04 27.405 19.49C26.965 19.93 26.33 20.15 25.5 20.15ZM25.5 13.775C26.08 13.775 26.37 13.425 26.37 12.725V11.9C26.37 11.2 26.08 10.85 25.5 10.85C24.92 10.85 24.63 11.2 24.63 11.9V12.725C24.63 13.425 24.92 13.775 25.5 13.775ZM25.5 18.65C26.12 18.65 26.43 18.255 26.43 17.465V16.46C26.43 15.67 26.12 15.275 25.5 15.275C24.88 15.275 24.57 15.67 24.57 16.46V17.465C24.57 18.255 24.88 18.65 25.5 18.65Z",
    fill: "#111820"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2913",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2913"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2913",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18);
export default __webpack_public_path__ + "static/media/18.59bfaa94762df8f97b15540f3cabb98d.svg";
export { ForwardRef as ReactComponent };